import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../context/Auth';
import styles from '../../../pages/Home.module.css';
import InputTag from '../FormComponents/InputTag';
import { LogInBtnIcon } from '../../icons/Icon';
import { PInloginIcon } from '../../icons/Icon2';

const Pinlogin = ({ loading, handleClick, confirmPin, setConfirmPin, name }) => {
    const { mode } = useAuth();
    const [error, setError] = useState('');
    const confirmPinRefs = useRef([]);
    const [cooldownTime, setCooldownTime] = useState(0);

    useEffect(() => {
        const checkCooldown = () => {
            const cooldownData = JSON.parse(localStorage.getItem("pinCooldown"));
            if (cooldownData?.lockUntil) {
                const now = Date.now();
                const timeLeft = Math.floor((cooldownData.lockUntil - now) / 1000); 
                if (timeLeft > 0) {
                    setCooldownTime(timeLeft);
                } else {
                    setCooldownTime(0);
                }
            }
        };

        checkCooldown();
        const interval = setInterval(() => {
            setCooldownTime((prev) => {
                if (prev > 1) return prev - 1;
                return 0;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);
    
    const handlePinChange = (value, index) => {
        if (value.length > 1 || !/^\d$/.test(value)) return;

        const updatedConfirmPin = [...confirmPin];
        updatedConfirmPin[index] = value;
        setConfirmPin(updatedConfirmPin);

        setTimeout(() => {
            if (value && index < 5) {
                confirmPinRefs.current[index + 1].focus();
            }
        }, 100);
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace') {
            const updatedConfirmPin = [...confirmPin];
            updatedConfirmPin[index] = '';
            setConfirmPin(updatedConfirmPin);

            if (index > 0) confirmPinRefs.current[index - 1].focus();
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const confirmPinValue = confirmPin.join('');

        if (confirmPinValue.length !== 6) {
            setError('PIN must be exactly 6 digits.');
            return;
        }

        setError('');
        handleClick()
    };

    useEffect(() => {
        if (confirmPin.every((item) => item !== '')) {
            handleClick();
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirmPin]);

    return (
        <div
            className={styles.login_container}
            style={mode ? { backgroundColor: '#2C2E33' } : {}}
        >
            <div
                className={styles.login1}
                style={mode ? { backgroundColor: '#232529' } : {}}
            >
                <div className={styles.sub_Login}>
                    <div className={styles.login_Header}>
                        <div className={styles.login_Header_Text}>
                            <h2 style={mode ? { color: '#ffffff' } : {}}>Login</h2>
                            <p style={mode ? { color: '#9C9797' } : {}}>
                                Now you are able to login to your account with your PIN
                            </p>
                        </div>
                        <div>
                            <PInloginIcon />
                        </div>
                    </div>
                    <form className={styles.login_Form} onSubmit={handleSubmit}>
                        <div className={styles.loginFormconintener}>
                            <div className={styles.input_group}>
                                <InputTag
                                    maxLength={50}
                                    // value={ localStorage.getItem("loginName") || localStorage.getItem('loginID')}
                                    value={name || localStorage.getItem("loginName")}
                                    readOnly={true}
                                />
                            </div>
                            <div
                                className={styles.input_group}
                                style={{ marginTop: '20px' }}
                            >
                                <label
                                    className={styles.input_Tage_lable}
                                    style={mode ? { color: '#ffffff' } : {}}
                                >
                                    Enter PIN
                                </label>
                                <div className={styles.pin_container}>
                                    {confirmPin.map((digit, index) => (
                                        <input
                                            key={index}
                                            // type="tel"
                                            type='password'
                                            autoFocus={index === 0 ? true : false}
                                            maxLength={1}
                                            value={digit}
                                            onChange={(e) => handlePinChange(e.target.value, index)}
                                            onKeyDown={(e) => handleKeyDown(e, index)}
                                            className={styles.pin_input}
                                            ref={(el) => (confirmPinRefs.current[index] = el)}
                                            style={{
                                                backgroundColor: mode ? '#1B1D21' : '#fff',
                                                color: mode ? '#fff' : '#000',
                                                border: mode ? 'none' : '1px solid #E4E7EB',
                                            }}
                                            autoComplete={"new-password"}
                                            disabled={cooldownTime > 0}
                                        />
                                    ))}
                                </div>
                            </div>
                            {error && (
                                <div className={styles.error_message}>{error}</div>
                            )}
                            {cooldownTime > 0 && (
                                <div className={styles.error_message} >
                                    Please wait {Math.floor(cooldownTime / 60)}m {cooldownTime % 60}s before trying again.
                                </div>
                            )}

                            <button
                                type="submit"
                                disabled={loading}
                                className={styles.login_button}
                                style={{ marginTop: '20px' }}
                            >
                                {loading ? (
                                    <>
                                        <span className={styles.spinner}></span>
                                        <p>Loading...</p>
                                    </>
                                ) : (
                                    <>
                                        <LogInBtnIcon />
                                        <p>Login</p>
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                    <div style={{ marginTop: "40px" }} />
                </div>
            </div>
        </div>
    );
};

export default Pinlogin;




